// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rejection Modal Specific Styles */
.RejectLeaveRequest_rejectModal__pK\\+BL {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000; /* higher than most page elements */
  padding: 2px;
}

.RejectLeaveRequest_rejectModalContent__9mi\\+c {
  background-color: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  overflow: hidden;
}

.RejectLeaveRequest_rejectModalHeader__w4EZv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.RejectLeaveRequest_rejectModalTitle__brkth {
  color: var(--Slate-700, #334155);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
}

.RejectLeaveRequest_rejectCloseButton__YilL2 {
  color: #6b7280;
}

.RejectLeaveRequest_rejectCloseButton__YilL2:hover {
  background-color: #f3f4f6;
}

.RejectLeaveRequest_rejectModalBody__B0ikS {
  padding: 24px;
}

.RejectLeaveRequest_rejectConfirmationText__ejOw- {
  color: var(--Slate-800, #1e293b);
  margin-bottom: 10px;
  /* Inter/Body md/Body md - semibold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}

.RejectLeaveRequest_rejectWarningText__mkW6Y {
  color: red;

  /* text-sm/leading-5/normal */
  font-family: var(--font-family-font-sans, Inter);
  font-size: text-sm;
  font-style: normal;
  font-weight: var(--font-weight-font-normal, 400);
  line-height: leading-5; /* 142.857% */
  margin-bottom: 16px;
}

.RejectLeaveRequest_rejectRemarkSection__X4kzJ {
  /* margin-bottom: 24px; */
}

.RejectLeaveRequest_rejectRemarkLabel__nYjz3 {
  color: var(--Gray-800, #1f2937);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
}

.RejectLeaveRequest_rejectRemarkTextarea__eUbvR {
  width: 100%;
  min-height: 140px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  resize: vertical;
  outline: none;
  position: relative;
  z-index: 2100; /* Higher than modal overlay */
  background-color: white;
  pointer-events: auto;
  cursor: text;
}

.RejectLeaveRequest_rejectModalFooter__Hr7-S {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 16px 24px 24px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #fff;
}

.RejectLeaveRequest_rejectCancelButton__AYRmb {
  /* border: 1px solid #d1d5db; */
  color: #374151;
  text-transform: none;
  font-weight: 500;
  padding: 7px 24px;
  border-radius: 8px;
  background-color: rgba(241, 245, 249, 1);
  min-width: 100px;
}

.RejectLeaveRequest_rejectCancelButton__AYRmb:hover {
  border-color: #9ca3af;
  background-color: #f3f4f6;
}

.RejectLeaveRequest_rejectConfirmButton__R3hBN {
  background-color: rgba(220, 38, 38, 1);
  text-transform: none;
  font-weight: 500;
  padding: 7px 24px;
  border-radius: 8px;
  color: white;
  min-width: 100px;
}

.RejectLeaveRequest_rejectConfirmButton__R3hBN:hover {
  background-color: #b91c1c;
}

/* Responsive adjustments */

/* Tablet (1024px) */
@media (max-width: 1024px) {
  .RejectLeaveRequest_rejectModalContent__9mi\\+c {
    max-width: 450px;
  }

  .RejectLeaveRequest_rejectModalTitle__brkth {
    font-size: 19px;
  }

  .RejectLeaveRequest_rejectConfirmationText__ejOw- {
    font-size: 15px;
  }
}

/* Mobile (768px) */
@media (max-width: 768px) {
  .RejectLeaveRequest_rejectModal__pK\\+BL {
    padding: 12px;
  }

  .RejectLeaveRequest_rejectModalContent__9mi\\+c {
    max-width: 420px;
    border-radius: 10px;
  }

  .RejectLeaveRequest_rejectModalTitle__brkth {
    font-size: 18px;
  }

  .RejectLeaveRequest_rejectConfirmationText__ejOw- {
    font-size: 15px;
  }

  .RejectLeaveRequest_rejectRemarkTextarea__eUbvR {
    min-height: 120px;
    font-size: 13px;
  }

  .RejectLeaveRequest_rejectCancelButton__AYRmb,
  .RejectLeaveRequest_rejectConfirmButton__R3hBN {
    padding: 10px 20px !important;
    width: 100%;
  }

  .RejectLeaveRequest_rejectModalFooter__Hr7-S {
    flex-direction: column-reverse;
    gap: 12px;
  }
}

/* Small Mobile (480px) */
@media (max-width: 480px) {
  .RejectLeaveRequest_rejectModal__pK\\+BL {
    /* padding: 8px; */
  }

  .RejectLeaveRequest_rejectModalContent__9mi\\+c {
    max-width: 100%;
    border-radius: 8px;

    margin: 0px 24px;
  }

  .RejectLeaveRequest_rejectModalHeader__w4EZv {
    /* padding: 14px 12px; */
  }

  .RejectLeaveRequest_rejectModalBody__B0ikS {
    /* padding: 12px; */
  }

  .RejectLeaveRequest_rejectModalTitle__brkth {
    font-size: 17px;
  }

  .RejectLeaveRequest_rejectModalHeader__w4EZv,
  .RejectLeaveRequest_rejectModalBody__B0ikS,
  .RejectLeaveRequest_rejectModalFooter__Hr7-S {
    padding: 18px;
  }
  .RejectLeaveRequest_rejectConfirmationText__ejOw- {
    font-size: 14px;
    line-height: 20px;
  }

  .RejectLeaveRequest_rejectRemarkTextarea__eUbvR {
    min-height: 100px;
    font-size: 13px;
  }

  .RejectLeaveRequest_rejectModalFooter__Hr7-S {
    /* padding: 12px; */
    flex-direction: column-reverse;
    gap: 10px;
  }

  .RejectLeaveRequest_rejectCancelButton__AYRmb,
  .RejectLeaveRequest_rejectConfirmButton__R3hBN {
    width: 100%;
    padding: 10px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/components/RejectLeaveRequest.module.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,mCAAmC;EAClD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,UAAU;;EAEV,6BAA6B;EAC7B,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB,EAAE,aAAa;EACrC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,aAAa,EAAE,8BAA8B;EAC7C,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;;AAE3B,oBAAoB;AACpB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;;IAElB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* Rejection Modal Specific Styles */\n.rejectModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000; /* higher than most page elements */\n  padding: 2px;\n}\n\n.rejectModalContent {\n  background-color: white;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.rejectModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rejectModalTitle {\n  color: var(--Slate-700, #334155);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n}\n\n.rejectCloseButton {\n  color: #6b7280;\n}\n\n.rejectCloseButton:hover {\n  background-color: #f3f4f6;\n}\n\n.rejectModalBody {\n  padding: 24px;\n}\n\n.rejectConfirmationText {\n  color: var(--Slate-800, #1e293b);\n  margin-bottom: 10px;\n  /* Inter/Body md/Body md - semibold */\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n}\n\n.rejectWarningText {\n  color: red;\n\n  /* text-sm/leading-5/normal */\n  font-family: var(--font-family-font-sans, Inter);\n  font-size: text-sm;\n  font-style: normal;\n  font-weight: var(--font-weight-font-normal, 400);\n  line-height: leading-5; /* 142.857% */\n  margin-bottom: 16px;\n}\n\n.rejectRemarkSection {\n  /* margin-bottom: 24px; */\n}\n\n.rejectRemarkLabel {\n  color: var(--Gray-800, #1f2937);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n\n.rejectRemarkTextarea {\n  width: 100%;\n  min-height: 140px;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  resize: vertical;\n  outline: none;\n  position: relative;\n  z-index: 2100; /* Higher than modal overlay */\n  background-color: white;\n  pointer-events: auto;\n  cursor: text;\n}\n\n.rejectModalFooter {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 16px 24px 24px 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #fff;\n}\n\n.rejectCancelButton {\n  /* border: 1px solid #d1d5db; */\n  color: #374151;\n  text-transform: none;\n  font-weight: 500;\n  padding: 7px 24px;\n  border-radius: 8px;\n  background-color: rgba(241, 245, 249, 1);\n  min-width: 100px;\n}\n\n.rejectCancelButton:hover {\n  border-color: #9ca3af;\n  background-color: #f3f4f6;\n}\n\n.rejectConfirmButton {\n  background-color: rgba(220, 38, 38, 1);\n  text-transform: none;\n  font-weight: 500;\n  padding: 7px 24px;\n  border-radius: 8px;\n  color: white;\n  min-width: 100px;\n}\n\n.rejectConfirmButton:hover {\n  background-color: #b91c1c;\n}\n\n/* Responsive adjustments */\n\n/* Tablet (1024px) */\n@media (max-width: 1024px) {\n  .rejectModalContent {\n    max-width: 450px;\n  }\n\n  .rejectModalTitle {\n    font-size: 19px;\n  }\n\n  .rejectConfirmationText {\n    font-size: 15px;\n  }\n}\n\n/* Mobile (768px) */\n@media (max-width: 768px) {\n  .rejectModal {\n    padding: 12px;\n  }\n\n  .rejectModalContent {\n    max-width: 420px;\n    border-radius: 10px;\n  }\n\n  .rejectModalTitle {\n    font-size: 18px;\n  }\n\n  .rejectConfirmationText {\n    font-size: 15px;\n  }\n\n  .rejectRemarkTextarea {\n    min-height: 120px;\n    font-size: 13px;\n  }\n\n  .rejectCancelButton,\n  .rejectConfirmButton {\n    padding: 10px 20px !important;\n    width: 100%;\n  }\n\n  .rejectModalFooter {\n    flex-direction: column-reverse;\n    gap: 12px;\n  }\n}\n\n/* Small Mobile (480px) */\n@media (max-width: 480px) {\n  .rejectModal {\n    /* padding: 8px; */\n  }\n\n  .rejectModalContent {\n    max-width: 100%;\n    border-radius: 8px;\n\n    margin: 0px 24px;\n  }\n\n  .rejectModalHeader {\n    /* padding: 14px 12px; */\n  }\n\n  .rejectModalBody {\n    /* padding: 12px; */\n  }\n\n  .rejectModalTitle {\n    font-size: 17px;\n  }\n\n  .rejectModalHeader,\n  .rejectModalBody,\n  .rejectModalFooter {\n    padding: 18px;\n  }\n  .rejectConfirmationText {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .rejectRemarkTextarea {\n    min-height: 100px;\n    font-size: 13px;\n  }\n\n  .rejectModalFooter {\n    /* padding: 12px; */\n    flex-direction: column-reverse;\n    gap: 10px;\n  }\n\n  .rejectCancelButton,\n  .rejectConfirmButton {\n    width: 100%;\n    padding: 10px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rejectModal": `RejectLeaveRequest_rejectModal__pK+BL`,
	"rejectModalContent": `RejectLeaveRequest_rejectModalContent__9mi+c`,
	"rejectModalHeader": `RejectLeaveRequest_rejectModalHeader__w4EZv`,
	"rejectModalTitle": `RejectLeaveRequest_rejectModalTitle__brkth`,
	"rejectCloseButton": `RejectLeaveRequest_rejectCloseButton__YilL2`,
	"rejectModalBody": `RejectLeaveRequest_rejectModalBody__B0ikS`,
	"rejectConfirmationText": `RejectLeaveRequest_rejectConfirmationText__ejOw-`,
	"rejectWarningText": `RejectLeaveRequest_rejectWarningText__mkW6Y`,
	"rejectRemarkSection": `RejectLeaveRequest_rejectRemarkSection__X4kzJ`,
	"rejectRemarkLabel": `RejectLeaveRequest_rejectRemarkLabel__nYjz3`,
	"rejectRemarkTextarea": `RejectLeaveRequest_rejectRemarkTextarea__eUbvR`,
	"rejectModalFooter": `RejectLeaveRequest_rejectModalFooter__Hr7-S`,
	"rejectCancelButton": `RejectLeaveRequest_rejectCancelButton__AYRmb`,
	"rejectConfirmButton": `RejectLeaveRequest_rejectConfirmButton__R3hBN`
};
export default ___CSS_LOADER_EXPORT___;
